export default {
  title: '{{company}} actualizó tu hora de recogida',
  title_on_site: '{{company}} ha actualizado cuándo se sirve tu pedido',
  new_time_label: 'Nueva hora',
};
